import { z } from 'zod'

export const SLAT_SHAPE_KEYS = ['WoodSlat4Ft', 'WoodSlat8Ft'] as const
export type SlatShapeKey = typeof SLAT_SHAPE_KEYS[number]
export const slatShapeSchema = z.object({
  key: z.enum(SLAT_SHAPE_KEYS),
  family: z.literal('Slats'),
  label: z.string().trim().min(1).max(100),
  width_in: z.number().finite().positive().max(1200),
  height_in: z.number().finite().positive().max(1200),
  depth_in: z.number().finite().positive().max(120),
})
export type SlatShape = z.infer<typeof slatShapeSchema>
export const DEFAULT_SLAT_SHAPES: SlatShape[] = [
  { key: 'WoodSlat4Ft', family: 'Slats', label: '4 ft Slats', width_in: 25.2, height_in: 47.245, depth_in: 0.875 },
  { key: 'WoodSlat8Ft', family: 'Slats', label: '8 ft Slats', width_in: 25.2, height_in: 94.49, depth_in: 0.875 },
]

export const slatShapeKey = (row: { shape_key?: string | null; product_id?: string | number | null }): SlatShapeKey | undefined => {
  if (SLAT_SHAPE_KEYS.includes(row.shape_key as SlatShapeKey)) return row.shape_key as SlatShapeKey
  if (row.shape_key) return undefined
  if (String(row.product_id) === '9217478983908') return 'WoodSlat4Ft'
  if (String(row.product_id) === '9211342946532') return 'WoodSlat8Ft'
}
